import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=0ba14656"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ba14656')) {
      api.createRecord('0ba14656', component.options)
    } else {
      api.reload('0ba14656', component.options)
    }
    module.hot.accept("./PageNotFound.vue?vue&type=template&id=0ba14656", function () {
      api.rerender('0ba14656', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/http/views/PageNotFound.vue"
export default component.exports